import React, { useState } from 'react';
import { PageUiNavBar } from 'components/Layout/PageNavBar/PageUiNavBar';
import { WarehouseTable } from './tables/WarehouseTable';
import { QrWarehouseScanner } from '../../components/QrScanner/QrWarehouseScanner';
import { useFetchWarehouseOrdersArray } from 'hooks/useFetchWarehouseOrders';
import { NrOfWarehouseOrders } from './NrOfWarehouseOrders';
import './WarehouseSystem.scss';
import { Helmet } from 'react-helmet';
import './Widget.scss';
import { ReqEnum } from '../../const/requestStatus';
import { OrderStatus } from '../../types/orderTypes';
import { capitalize } from '../../utils/strings';

export interface WarehouseOrder {
  orderId: string;
  orderStatus: OrderStatus;
  deliveryDay: string;
  hasDeviations: boolean;
  createdAt?: Date;
  parcelIds?: ParcelWithLocation[];
  updatedAt?: Date;
}

export interface ParcelWithLocation {
  parcelId: string;
  warehouseLocation: string;
}

export function WarehouseSystem() {
  const {
    orders,
    fetchStatus,
    deleteOrder,
    addScannedOrder,
    setScannerIsOpen,
    scannerIsOpen,
    deleteScannedOrder,
    updateScannedOrder,
    flash,
  } = useFetchWarehouseOrdersArray();
  return (
    <WarehouseSystemUI
      orders={orders}
      fetchStatus={fetchStatus}
      deleteOrder={deleteOrder}
      addScannedOrder={addScannedOrder}
      setScannerIsOpen={setScannerIsOpen}
      scannerIsOpen={scannerIsOpen}
      deleteScannedOrder={deleteScannedOrder}
      updateScannedOrder={updateScannedOrder}
      flash={flash}
    />
  );
}

export function WarehouseSystemUI({
  orders,
  fetchStatus,
  deleteOrder,
  addScannedOrder,
  setScannerIsOpen,
  scannerIsOpen,
  deleteScannedOrder,
  updateScannedOrder,
  flash,
}) {
  const [toggleScanPackageMode, setToggleScanPackageMode] =
    useState<string>('ADD');

  const [warehouseLocation, setWarehouseLocation] = useState(null);

  const ordersOrderidList: string[] = orders.map(
    (order: WarehouseOrder) => order.orderId
  );

  const addPackageMethod = () => {
    setToggleScanPackageMode('ADD');
    // setTimeout(() => {
    //   setScannerIsOpen(true);
    // }, 300);
  };

  const removePackageMethod = () => {
    setToggleScanPackageMode('REMOVE');
    // setTimeout(() => {
    //   setScannerIsOpen(true);
    // }, 300);
  };

  // const warehouseLocation = warehouseLocations.OSLO.RYEN

  const AddEditScanning = () => {
    return (
      <div className="AddEditScanning">
        <Helmet>
          <title>Warehouse - {capitalize(toggleScanPackageMode)} Package</title>
        </Helmet>
        <PageUiNavBar
          bars={[
            {
              text: `ADD PACKAGE`,
              method: () => addPackageMethod(),
              active: toggleScanPackageMode === 'ADD',
            },
            {
              text: `REMOVE PACKAGE`,
              method: () => removePackageMethod(),
              active: toggleScanPackageMode === 'REMOVE',
            },
          ]}
        />
        <div className="warhouseSystem">
          <div>
            {toggleScanPackageMode === 'ADD' ? (
              <QrWarehouseScanner
                titleButton={'ADD PACKAGE'}
                addScannedOrder={addScannedOrder}
                ordersOrderidList={ordersOrderidList}
                warehouseLocation={warehouseLocation}
                setWarehouseLocation={setWarehouseLocation}
                updateScannedOrder={updateScannedOrder}
                scannerIsOpen={scannerIsOpen}
                setScannerIsOpen={setScannerIsOpen}
              />
            ) : (
              <QrWarehouseScanner
                titleButton={'REMOVE PACKAGE'}
                addScannedOrder={addScannedOrder}
                deleteScannedOrder={deleteScannedOrder}
                ordersOrderidList={ordersOrderidList}
                warehouseLocation={warehouseLocation}
                setWarehouseLocation={setWarehouseLocation}
                scannerIsOpen={scannerIsOpen}
                setScannerIsOpen={setScannerIsOpen}
                addOrDelete={'DELETE'}
              />
            )}
          </div>
        </div>
      </div>
    );
  };

  return (
    <>
      <div
        className={flash ? ' warehousePageTop is-flashing' : 'warehousePageTop'}
      >
        <AddEditScanning />
      </div>
      <div
        className={
          flash ? ' warehousePageBottom is-flashing' : 'warehousePageBottom'
        }
      >
        <div className="warehouseTable">
          {fetchStatus === ReqEnum.SUCCESS && (
            <>
              <NrOfWarehouseOrders orders={orders} />
              <WarehouseTable orders={orders} deleteOrder={deleteOrder} />
            </>
          )}
        </div>
      </div>
    </>
  );
}
